function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M6.05 4.4a1.65 1.65 0 100 3.301 1.65 1.65 0 000-3.3zm14.985 5.182L11.783.32A1.1 1.1 0 0011 0h-9.9A1.1 1.1 0 000 1.1v9.901a1.1 1.1 0 00.32.782l9.262 9.252a3.3 3.3 0 004.665 0l6.788-6.733a3.3 3.3 0 000-4.665v-.055zm-1.551 3.103l-6.8 6.788a1.1 1.1 0 01-1.55 0L2.2 10.55V2.2h8.35l8.934 8.933a1.1 1.1 0 010 1.552z",
  fill: "currentColor",
  fillRule: "evenodd"
})));